module.exports = __webpack_public_path__ + "img/vegetables-1.8b091222.jpg";